import colors from 'seagull/foundations/colors.module.scss';
/** Shared preset solid colors for branding color selectors (primary, accent, etc.). */ export const PRESET_SOLID_COLORS = [
    colors.dark900,
    colors.dark800,
    colors.dark700,
    colors.dark500,
    colors.dark200,
    colors.dark50,
    colors.purple900,
    colors.purple800,
    colors.purple700,
    colors.purple500,
    colors.purple300,
    colors.purple50,
    colors.blue800,
    colors.blue700,
    colors.blue600,
    colors.blue500,
    colors.blue300,
    colors.blue50,
    colors.green900,
    colors.green800,
    colors.green700,
    colors.green500,
    colors.green300,
    colors.green50,
    colors.orange900,
    colors.orange800,
    colors.orange700,
    colors.orange500,
    colors.orange300,
    colors.orange50,
    colors.red970,
    colors.red900,
    colors.red700,
    colors.red500,
    colors.red300,
    colors.red200
];
export const PRESET_GRADIENTS = [
    [
        '#E7E7FF',
        '#E7F5FF'
    ],
    [
        '#FFEEF0',
        '#E6F2FF'
    ],
    [
        '#E3DFFF',
        '#FFEAE0'
    ],
    [
        '#E7FCFF',
        '#FFD9D1'
    ],
    [
        '#E6F9F3',
        '#FDF5E6'
    ],
    [
        '#EEFFFC',
        '#BDD4EA'
    ],
    [
        '#454AC4',
        '#2C1B6E'
    ],
    [
        '#305B5B',
        '#211C3B'
    ],
    [
        '#7A2934',
        '#2C1B6E'
    ],
    [
        '#724A70',
        '#13216E'
    ],
    [
        '#84704D',
        '#3C2463'
    ],
    [
        '#BE8268',
        '#282863'
    ]
];
